import capitalLogo from "../../assets/ventures/capital.png";
import demodayLogo from "../../assets/ventures/demoday.png";
import startupLogo from "../../assets/ventures/startup_school.png";
import vectorLogo from "../../assets/ventures/vector.png";

import BoletimSection from "../BoletimSection/BoletimSection";
import CardImageGrid from "../CardImageGrid/CardImageGrid";

function Ventures({ ventures }) {
	const VENTURES_OPTIONS = [
        {
            desc: "Startup School",
            image: startupLogo,
            disabled: ventures.includes("startup") ? false : true,
            show: true,
        },
        {
            desc: "Vector",
            image: vectorLogo,
            disabled: ventures.includes("mi5") || ventures.includes("vector") ? false : true,
            show: true,
        },
		{
			desc: "Demoday",
			image: demodayLogo,
			disabled: ventures.includes("demoday") ? false : true,
            show: true,
		},
		{
			desc: "Capital",
			image: capitalLogo,
			disabled: ventures.includes("capital") ? false : true,
            show: true,
		},
	];
	return (
		<BoletimSection
			title="Ventures"
			icon="ventures"
		>
			<CardImageGrid
				type={"ventures"}
				items={VENTURES_OPTIONS}
			/>
		</BoletimSection>
	);
}

export default Ventures;
